// Shopify Subscriptions Dropdown Functionality

document.addEventListener('DOMContentLoaded', function() {
  const fieldset = document.querySelector('.shopify_subscriptions_fieldset');
  
  if (!fieldset) return;
  
  const oneTimePurchaseWrapper = fieldset.querySelector('.shopify_subscriptions_app_block_label:has(.shopify_subscriptions_app_block_one_time_purchase_option)');
  const oneTimePurchaseRadio = fieldset.querySelector('.shopify_subscriptions_app_block_one_time_purchase_option');
  const subscriptionLabels = fieldset.querySelectorAll('.shopify_subscriptions_app_block_label:not(:has(.shopify_subscriptions_app_block_one_time_purchase_option))');
  
  // Toggle dropdown when clicking one-time purchase wrapper
  if (oneTimePurchaseWrapper) {
    oneTimePurchaseWrapper.addEventListener('click', function(e) {
      // If clicking the radio button itself, let it work normally
      if (e.target === oneTimePurchaseRadio) {
        fieldset.classList.remove('subscription-expanded');
        return;
      }
      
      // Otherwise toggle the dropdown
      fieldset.classList.toggle('subscription-expanded');
    });
  }
  
  // When any subscription option is clicked, expand and select it
  subscriptionLabels.forEach(function(label) {
    const purchaseWrapper = label.querySelector('.shopify_subscriptions_purchase_option_wrapper');
    const radioInput = label.querySelector('input[type="radio"]');
    
    if (purchaseWrapper && radioInput) {
      purchaseWrapper.addEventListener('click', function() {
        fieldset.classList.add('subscription-expanded');
        radioInput.checked = true;
      });
    }
  });
  
  // Initialize: collapsed by default
  fieldset.classList.remove('subscription-expanded');
});
